import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from '@elight/client/shared/utility/auth';

@Injectable()
export class RoleVoter {
    constructor(private authService: AuthService) {}

    hasAccess(roles: string[]): Observable<boolean> {
        return this.authService.currentUser$.pipe(
            map((user) => this.isAllowed(roles, user?.roles))
        );
    }

    private isAllowed(
        roles?: string[] | null | undefined,
        userRoles?: string[]
    ): boolean {
        if (!roles) {
            return true;
        }
        if (!userRoles) {
            return false;
        }
        let isAllowed = false;
        userRoles.forEach((userRole) => {
            if (roles.includes(userRole)) {
                isAllowed = true;
            }
        });

        return isAllowed;
    }
}
